'use client';
import { routes } from '~constants/routes';
import { useTranslations } from '~i18n/hooks';
import { useGetLocationQuery } from '~services/api/location';
import { ButtonGhost } from '~shared/ui/molecules';

import { TOCWrapper } from './styles';

type Props = {
	refund?: boolean;
	onReviewClick?: () => void;
};

export const ToC = ({ refund, onReviewClick }: Props) => {
	const { data, isFetching } = useGetLocationQuery(undefined);
	const showComplaints = !isFetching && data?.country === 'US';
	const t = useTranslations('TermsLinks');

	return (
		<TOCWrapper size="M" color="semi-transparent">
			{showComplaints && (
				<a href={routes.complaints.home} target="_blank">
					{t('complaintsPolicyLinkText')}
				</a>
			)}
			<a href={routes.terms.home} target="_blank">
				{t('termsLinkText')}
			</a>
			<a href={routes.privacy.home} target="_blank">
				{t('privacyLinkText')}
			</a>
			<a href={routes.support.home} target="_blank">
				{t('supportLinkText')}
			</a>
			{refund ? (
				<a href={routes.refund.home} target="_blank">
					{t('refundPolicyLinkText')}
				</a>
			) : null}
			{onReviewClick && (
				<ButtonGhost onClick={onReviewClick}>
					{t('feedbackFormButtonText')}
				</ButtonGhost>
			)}
		</TOCWrapper>
	);
};
